import { Icon } from '@acme/assets';
import { Button } from 'flowbite-react';
import { HiX } from 'react-icons/hi';

interface IDeleteRateModalProps {
  label: string;
  onClose: () => void;
  onApprove?: () => void;
}

export const DeleteRateModal = (props: IDeleteRateModalProps) => {
  return (
    <div>
      <div className="flex justify-end">
        <button
          onClick={props.onClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <HiX className="h-3 w-3" />
        </button>
      </div>
      <div className="flex flex-col p-5 gap-4 items-center">
        <Icon name="exclamation" color="#9CA3AF" className="h-5 w-5" />
        <div className="text-base font-normal text-gray-500">{props.label}</div>
      </div>
      <div className="flex gap-4 justify-center">
        <Button color="red" onClick={props.onApprove}>
          Да, удалить
        </Button>
        <Button color="gray" onClick={props.onClose}>
          Нет, отмена
        </Button>
      </div>
    </div>
  );
};
